<template>
  <!-- Main modal -->
  <div
    tabindex="-1"
    id="modal-bg"
    class="w-screen h-screen bg-black opacity-20 top-0 left-0 fixed"
    :class="[show ? '' : 'hidden']"
    :style="{ 'z-index': zIndex }"
  ></div>

  <div
    class="fixed top-0 left-0 w-screen h-screen"
    :class="[show ? '' : 'hidden']"
    :style="{ 'z-index': zIndex + 10 }"
  >
    <div class="flex h-full justify-center items-center">
      <div
        id="popup-modal"
        tabindex="-1"
        class="w-[90vw] md:w-fit bg-white rounded-2xl shadow"
        :class="[draggable ? 'absolute' : '']"
        ref="popupModal"
        :style="{ 'z-index': zIndex + 10, top: position.y + 'px', left: position.x + 'px' }"
        @mousedown.stop="startDrag"
      >
        <div
          class="relative w-full bg-white flex rounded-2xl flex-col"
          :class="[draggable ? 'modal-header' : '']"
          ref="modalContent"
        >
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    zIndex: {
      type: Number,
      default: 10,
    },
    draggable: {
      type: Boolean,
      default: false,
    },
    initialPosition: {
      type: Object,
      default: () => ({ x: 100, y: 100 }),
    },
  },
  emits: ['close'],
  data() {
    return {
      position: { ...this.initialPosition },
      dragging: false,
      offset: { x: 0, y: 0 },
    }
  },
  mounted() {
    if (this.draggable) {
      document.addEventListener('mousemove', this.onMouseMove)
      document.addEventListener('mouseup', this.stopDrag)
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    startDrag(event) {
      if (!this.draggable) {
        return
      }

      this.dragging = true
      this.offset = {
        x: event.clientX - this.position.x,
        y: event.clientY - this.position.y,
      }
    },
    stopDrag() {
      if (!this.draggable) {
        return
      }
      this.dragging = false
    },
    onMouseMove(event) {
      if (!this.draggable) {
        return
      }
      if (this.dragging) {
        this.position = {
          x: event.clientX - this.offset.x,
          y: event.clientY - this.offset.y,
        }
      }
    },
  },
}
</script>
<style scoped>
.modal-header {
  cursor: move;
  user-select: none;
}
</style>
